import styled from 'styled-components';

export const AuthenticateStyled = styled.section`
  padding: 56px 0 80px;
  background-color: #ffffff;

  @media screen and (min-width: 992px) {
    padding: 120px 0;
  }
`;

export const Title = styled.h1`
  margin: 0 0 20px;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 500;
  color: #333333;

  @media screen and (min-width: 992px) {
    grid-column: 2 / 7;
    margin: 0;
    font-size: 32px;
  }
`;

export const List = styled.ul`
  padding-left: 16px;
  margin: 0;
  font-size: 16px;
  line-height: 27.2px;
  list-style: none;
  color: #727272;

  @media screen and (min-width: 992px) {
    grid-column: 8 / 12;
  }

  li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 32px;

    &:before {
      content: '';
      position: absolute;
      top: 12px;
      left: 0;
      width: 6px;
      height: 6px;
      background-color: #000000;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const VideoWrapper = styled.div`
  display: none;

  @media screen and (min-width: 992px) {
    display: block;
    max-width: 100%;
    min-height: 650px;
    margin: 0 auto;
  }

  @media screen and (min-width: 1200px) {
    max-width: 1200px;
    min-height: 640px;
  }

  video {
    max-width: 100%;
  }
`;

export const GraphicWrapper = styled.figure`
  margin-top: 60px;

  @media screen and (min-width: 992px) {
    grid-column: 2 / 12;
    margin-top: 120px;
  }

  img {
    max-width: 100%;
    &.mobile {
      @media screen and (min-width: 992px) {
        display: none;
      }
    }

    &.desktop {
      display: none;
      @media screen and (min-width: 992px) {
        display: block;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Authenticate/styled.js